import { TableCell } from '@e2n/ui';
import { Data } from '@/domain/controlling/entities/historie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { weathercodeMappings } from '../../utils';
import { NoData } from './NoData';

export function WetterCell({
  tagebuchData,
}: {
  tagebuchData: Data | undefined;
}) {
  return (
    <TableCell className="font-medium py-4 ps-4">
      {tagebuchData && tagebuchData.wetter ? (
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon
            className="size-5"
            icon={
              weathercodeMappings.find(
                (item) => item.code === tagebuchData.wetter.code,
              )?.icon?.day
            }
          />
          <div className="flex gap-[2px]">
            <div className="text-neutrals-700">
              {tagebuchData.wetter.minTemperatur}°
            </div>
            <div className="text-neutrals-700">/</div>
            <div className="text-neutrals-900 font-bold">
              {tagebuchData.wetter.maxTemperatur}°
            </div>
          </div>
        </div>
      ) : (
        <NoData />
      )}
    </TableCell>
  );
}
